import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AuthService } from 'src/app/core/services/auth.service';

import { TransactionService } from '../services/transaction.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionInvoiceService extends BaseProvider {
	costs:any = [];
	costQty: any = 1;

	subTotal: any = 0;	
	total: any = 0;	
	discountAmount: any = 0;
	selectedCosts: any = [];
	description: string;

	pendingInvoicelist: any;

	taxAmount: any = 0;

	totalOfNewCosts: any;
	costChange = new Subject();
	managementChange = new Subject();
	errors: any;

	invoice: any;

	invoices: any = [];
	receipts: any = [];
  	constructor(
  		public authService: AuthService,
  		public transactionService: TransactionService,
		public globals: GlobalsService,
		public utils: UtilsService,
 		public http: HttpClient,	
 		public ls: LsHelperService,
  	) { 
		super();

		this.baseUrl = "userProcessInvoice";		

	    this.costChange.subscribe((cost:any) => {
	    	this.manageCost(cost);
	    	this.setInvoiceTotal();
	   	});					
	}	

	clearCosts(){
		this.costs.forEach( 
			(cost, index) =>{
				cost.selected = false;
				cost.qty = 0;				
			}
		);
	}

	getInvoices(id): Promise<any[]> {
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/process/' + id;

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {
			    	this.list = data.Data;
					console.log('list',this.list)

					this.invoices = this.list

					resolve(data.Data);
			    },
			    err => {reject(err)}
			);
		});    
	} 

	getPendingInvoices(processId){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/userProcess/' + processId;

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {
			    	this.pendingInvoicelist = data.Data;

					resolve(data.Data);
			    },
			    err => {reject(err)}
			);
		});    
	} 	  		

	getCosts(id){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/process/' + id + '/cost';

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {
			    	this.costs = data.Data;		
					resolve(data.Data);
			    },
			    err => {reject(err)}
			);
		});    
	}   	

	saveInvoice(invoiceId){
		return new Promise( (resolve, reject) => {	
			let data = {
				TotalAmount: this.total ? this.total : 0,
				DiscountAmount: this.discountAmount ? this.discountAmount : 0,
				Costs: this.selectedCosts,
				InvoiceId: invoiceId?invoiceId:0,
				TaxAmount: this.taxAmount ? this.taxAmount : 0,
				Description: this.description
			};				
			if(invoiceId>0){
				this.updateInvoice(data).then((data)=>{
					resolve(data);
				});				
			}else{
				return this.createInvoice(data).then((data)=>{
					resolve(data);
				});
			}
	    });   				
	}

	createInvoice(data){
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + 
	      			 this.baseUrl + 
	      			 `/process/${this.transactionService.itemToEdit.Id}/cost`;

	        this.http
	        .post(
	          this.url, 
	          data
	        )
	        .subscribe(
	            (resp: any) => {
	                resolve(resp);
	            },
	            err => {reject(err)}
	        );
	    });   			
	}

	updateInvoice(data){
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + 
	      			 this.baseUrl + 
	      			 `/process/${this.transactionService.itemToEdit.Id}` +
	      			 `/cost/${data.InvoiceId}`;

	        this.http
	        .put(
	          this.url, 
	          data
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    });   			
	}	

	setInvoiceTotal(){
		this.subTotal = 0;

		this.selectedCosts.forEach((element:any, index) => {
		    this.subTotal += (element.Amount*element.Qty);
		});		

		this.total = this.subTotal;

		// this.taxAmount = (this.total *  0.04);

		this.total = this.total + this.taxAmount;

		this.setDiscount();
	}

	manageCost(obj:any){
		let foundItem = this
						.utils
						.returnItemFromListByAttr(this.selectedCosts, "Id", obj.cost.Id);	

		if(!this.utils.isEmpty(foundItem)){
			this
			.utils
			.updateItemFromListByAttr(
				this.selectedCosts, "Id", 
					{
						...obj.cost,
						...{Qty:parseInt(obj.qty)}	
					}
			);
		}else{
			this.selectedCosts.push({
				...obj.cost,
				...{Qty:parseInt(obj.qty)}					
			});	
		}		
	}	

	removeCost(cost){
		this
		.utils
		.removeItemFromListByAttr(
			this.selectedCosts, 
			"Id",
			cost			
		);		
	}

	setDiscount(){
		if(this.discountAmount<=this.subTotal){
			this.total = (this.subTotal - this.discountAmount) + this.taxAmount;		
		}		
	}

	canManage(){
		let canManage = false;

		if(
			!this.transactionService.itemToEdit.IsFinalized 			
			&&
			this.transactionService.itemToEdit.AssignedToCurrentUser
			&&
			this.authService.hasPolicy("CanCreateInvoices")
		){
			canManage = true;
		}

		return canManage;
	}

	canCreateInvoice(){
		let canCreateInvoice = false;

		if(
			!this.transactionService.itemToEdit.IsFinalized 	
			&&
			this.transactionService.itemToEdit.AssignedToCurrentUser					
			&&
			this.transactionService.itemToEdit.HasDynamicCostsForInvoice
			&&
			this.authService.hasPolicy("CanCreateInvoices")
		){
			canCreateInvoice = true;
		}

		return canCreateInvoice;		
	}

	canPayInvoice(invoice){
		let canPay = false;

		if(
			this.transactionService.itemToEdit.Radicated
			&&
			!this.transactionService.itemToEdit.IsFinalized 			
			&&
			this.transactionService.itemToEdit.CreatedByCurrentUser==1
			&&
			invoice.PaidDate == null
		){
			canPay = true;
		}

		return canPay;
	}	

	unpaidInvoiceCount(){
		let count = 0;
		
		this.list.forEach((invoice)=>{
			count += (invoice.PaidDate == null) ? 1 : 0;
		});

		return count;
	}

	delete(params){
		return new Promise( (resolve, reject) => {
		  this.url = this.globals.dataUrl + this.baseUrl + "/additionalInvoice/" + params.Id;
			
		    this.http
		    .delete(
		      this.url
		    )
		    .subscribe(
		        (data: any) => {
		            resolve(data);
		        },
		        err => {reject(err)}
		    );
		});      
	} 
	
}
